module.exports = __webpack_public_path__ + "static/media/icon_percen.ec244d3f.svg";